<div class="command-page">
  <header class="command-header">
    <div>
      <span class="eyebrow"><i class="ri-radar-line"></i> Monitorização operacional</span>
      <h1>Posto de Comando</h1>
      <p>Escalas, efetivos e ocorrências recebidos em tempo real.</p>
    </div>
    <div class="header-actions">
      <span class="live-state" [class.online]="connectionState === 'connected'">
        <i class="ri-radio-button-line"></i>
        {{ notificationSvc.connectionStateLabel(connectionState) }}
      </span>
      <button type="button" class="refresh-button" (click)="atualizar()">
        <i class="ri-refresh-line"></i> Actualizar
      </button>
    </div>
  </header>

  <section class="command-kpis">
    <article><span class="kpi-icon blue"><i class="ri-alarm-warning-line"></i></span><div><small>Ocorrências</small><strong>{{ totalOcorrencias }}</strong></div></article>
    <article><span class="kpi-icon amber"><i class="ri-notification-badge-line"></i></span><div><small>Por confirmar</small><strong>{{ porConfirmar }}</strong></div></article>
    <article><span class="kpi-icon red"><i class="ri-error-warning-line"></i></span><div><small>urgentes</small><strong>{{ urgentes }}</strong></div></article>
    <article><span class="kpi-icon violet"><i class="ri-shield-cross-line"></i></span><div><small>Sem cobertura</small><strong>{{ semCobertura }}</strong></div></article>
  </section>

  <div class="command-grid">
    <section class="command-panel occurrence-panel">
      <div class="panel-header">
        <div><h2>Fluxo operacional</h2><p>Eventos do grupo PostoComando atualizados automaticamente.</p></div>
        <div class="filter-pills">
          <button [class.active]="filtro === 'todas'" (click)="filtro = 'todas'">Todas</button>
          <button [class.active]="filtro === 'nao-lidas'" (click)="filtro = 'nao-lidas'">Novas</button>
          <button [class.active]="filtro === 'Urgentes'" (click)="filtro = 'Urgentes'">Urgentes</button>
        </div>
      </div>

      <div class="empty-command" *ngIf="ocorrenciasVisiveis.length === 0">
        <i class="ri-radar-line"></i><strong>Sem ocorrências neste filtro</strong><span>As novas ocorrências aparecerão aqui automaticamente.</span>
      </div>
      <div class="event-list" *ngIf="ocorrenciasVisiveis.length">
        <button type="button" class="event-card" *ngFor="let item of ocorrenciasVisiveis" [class.unread]="!item.lida" [class.urgent]="notificationSvc.isUrgent(item)" (click)="abrirOcorrencia(item)">
          <span class="event-severity"><i [class]="notificationSvc.icon(item)"></i></span>
          <span class="event-main"><span class="event-top"><strong>{{ notificationSvc.entityCode(item) }} · {{ item.title }}</strong><time>{{ item.occurredAt | date:'dd/MM HH:mm' }}</time></span><span class="event-place"><i class="ri-map-pin-2-line"></i> {{ notificationSvc.contextLabel(item) }}</span><small>{{ item.description }}</small></span>
          <i class="ri-arrow-right-s-line event-arrow"></i>
        </button>
      </div>
    </section>

    <aside class="command-panel coverage-panel">
      <div class="panel-header"><div><h2>Alertas operacionais</h2><p>Postos que requerem intervenção.</p></div></div>
      <div class="coverage-ok" *ngIf="postosSemCobertura.length === 0"><i class="ri-shield-check-line"></i><strong>Cobertura normal</strong><span>Todos os postos têm escala activa.</span></div>
      <button type="button" class="coverage-card" *ngFor="let posto of postosSemCobertura" (click)="abrirPosto(posto)">
        <span class="coverage-icon"><i class="ri-user-unfollow-line"></i></span><span><strong>{{ posto.nome }}</strong><small>Sem cobertura na escala de hoje</small><em>{{ posto.codigo || 'Posto #' + posto.id }}</em></span><i class="ri-arrow-right-line"></i>
      </button>
    </aside>
  </div>
</div>
